"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createBackgroundCanvas = createBackgroundCanvas;
exports.createNegativeCanvas = createNegativeCanvas;
exports.createShadowCanvas = createShadowCanvas;
exports.getNewCanvas = getNewCanvas;
function getNewCanvas(width, height) {
  var canvas = document.createElement("canvas");
  canvas.width = width;
  canvas.height = height;
  return canvas;
}
function createBackgroundCanvas(baseCanvas, fillColor, canvasWidth, canvasHeight) {
  var backgroundCanvas = getNewCanvas(canvasWidth, canvasHeight);
  var backgroundContext = backgroundCanvas.getContext("2d");
  backgroundContext.drawImage(baseCanvas, 0, 0);
  backgroundContext.globalCompositeOperation = "source-in";
  backgroundContext.fillStyle = fillColor;
  backgroundContext.fillRect(0, 0, canvasWidth, canvasHeight);
  return backgroundCanvas;
}
function createNegativeCanvas(baseCanvas, fillColor, canvasWidth, canvasHeight) {
  var negativeCanvas = getNewCanvas(canvasWidth, canvasHeight);
  var negativeContext = negativeCanvas.getContext("2d");
  negativeContext.fillStyle = fillColor;
  negativeContext.fillRect(0, 0, canvasWidth, canvasHeight);
  negativeContext.globalCompositeOperation = "destination-out";
  negativeContext.drawImage(baseCanvas, 0, 0);
  return negativeCanvas;
}
function createShadowCanvas(baseCanvas, shadows, canvasWidth, canvasHeight) {
  var shadowCanvas = getNewCanvas(canvasWidth, canvasHeight);
  var shadowContext = shadowCanvas.getContext("2d");
  for (var i = 0; i < shadows.length; i++) {
    shadowContext.shadowOffsetX = shadows[i].offsetX;
    shadowContext.shadowOffsetY = shadows[i].offsetY;
    shadowContext.shadowColor = shadows[i].color;
    shadowContext.shadowBlur = shadows[i].blur;
    shadowContext.drawImage(baseCanvas, 0, 0);
  }
  shadowContext.globalCompositeOperation = "destination-out";
  shadowContext.drawImage(baseCanvas, 0, 0);
  return shadowCanvas;
}